import { __awaiter, __generator } from "tslib";
import { logErrorEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { OfficeWorkload, } from '@office-start/officehome-types';
import { logError } from '@office-start/telemetry-service';
import { isFirstUse, setUserStorageItem, } from '@office-start/user-storage-service';
import { setUserItem as setLocalStorageUserItem } from '@office-start/web-storage-utility';
import { checkIsSupportedPath } from '../helpers/checkIsSupportedPath';
import { getFirstRunStateFromStorageAndSync } from '../storage/getFirstRunStateFromStorageAndSync';
import { getLegacyFirstRunDataFromStorage } from '../storage/getLegacyFirstRunDataFromStorage';
/**
 * Handles gathering FirstRunState object from local & network storage sources.
 * Returns default object if storage sources come back empty
 * Also handles checking legacy FirstRunData object, converts to new data object
 *
 * @param identity
 * @param officeComponentContext
 * @param featureGates
 */
export function getNewUserState(identity, officeComponentContext, storageKey, inMockMode, getDefaultState, transformLegacyToCurrentState) {
    return __awaiter(this, void 0, void 0, function () {
        var options, isSupportedPath, skipUserStorage, firstRunState, isFirstUseFunctional, isCompleted, legacyPwaConsumerFirstRunData, err_1, message, fallbackState;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    options = {
                        correlationId: officeComponentContext.correlationId,
                        getAccessToken: officeComponentContext.getAccessToken,
                        getIdentity: function () { return Promise.resolve(identity); },
                        inMockMode: officeComponentContext.inMockMode,
                        jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                        officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                        workload: officeComponentContext.workload,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 7, , 8]);
                    isSupportedPath = checkIsSupportedPath(officeComponentContext);
                    if (!isSupportedPath) {
                        // TODO: update this to return null once type check is handled in OfficeHome
                        return [2 /*return*/, getDefaultState(true)];
                    }
                    if (inMockMode) {
                        return [2 /*return*/, getDefaultState(false)];
                    }
                    skipUserStorage = identity.isMsa &&
                        officeComponentContext.workload === OfficeWorkload.Hwa;
                    return [4 /*yield*/, getFirstRunStateFromStorageAndSync(options, identity, storageKey, skipUserStorage)];
                case 2:
                    firstRunState = _b.sent();
                    if (!(firstRunState === null)) return [3 /*break*/, 6];
                    isFirstUseFunctional = officeComponentContext.workload === OfficeWorkload.OfficeHome ||
                        officeComponentContext.workload ===
                            OfficeWorkload.OfficeHomeReact;
                    if (!isFirstUseFunctional) return [3 /*break*/, 3];
                    isCompleted = !isFirstUse();
                    firstRunState = getDefaultState(isCompleted);
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, getLegacyFirstRunDataFromStorage(options, identity, skipUserStorage)];
                case 4:
                    legacyPwaConsumerFirstRunData = _b.sent();
                    firstRunState = legacyPwaConsumerFirstRunData
                        ? transformLegacyToCurrentState(legacyPwaConsumerFirstRunData)
                        : getDefaultState(false);
                    _b.label = 5;
                case 5:
                    // write to storage so this block doesn't run again
                    setLocalStorageUserItem(identity.puid, "_".concat(storageKey), firstRunState);
                    setUserStorageItem(storageKey, firstRunState, options);
                    _b.label = 6;
                case 6: return [2 /*return*/, firstRunState];
                case 7:
                    err_1 = _b.sent();
                    message = "Couldn't determine FirstRunState: ".concat(err_1);
                    logErrorEvent(KnownInstrumentationEvents.FirstRunDetermineStateError, (_a = {},
                        _a["Error" /* InstrumentationParam.Error */] = message,
                        _a));
                    // TODO: Remove above telemetry once migrated over to OTEL
                    logError({
                        eventName: KnownInstrumentationEvents.FirstRunDetermineStateError,
                        errorType: 'FirstRun_Error',
                        area: 'FirstRun',
                        errorCategory: 'React',
                        message: message,
                    });
                    fallbackState = getDefaultState(true);
                    return [2 /*return*/, fallbackState];
                case 8: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getNewUserState.js.map